import { SaveOutlined, PaperClipOutlined, DeleteOutlined, UploadOutlined } from '@ant-design/icons';
import ModalTextForm from '@app/components/modal/ModalTextForm';
import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Modal, Row, Select, Space, Tabs, Upload } from 'antd';
import type { RcFile, UploadFile, UploadProps } from 'antd/es/upload/interface';
import viVN from 'antd/lib/date-picker/locale/vi_VN';
import dayjs from "dayjs";
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ContentHeader } from '../../components';
import { responseStatus, urlAdmin } from '../../constants';
import { Links } from '../../helpers/Links';
import { dateCommon, thoiGianCongTacCommon, validateMessages, validateMinMax } from '../../helpers/common';
import { NhanVienResponse } from '../../models/nhanvien/NhanVien';
import LoadingDetailPage from '../../modules/loading/LoadingDetailPage';
import { layCTNhanVien, luuNhanVien, luuTaiLieuHoSoNhanSu, xoaTaiLieuHoSoNhanSu } from '../../services/nhanvien';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import ChucDanhChuyenMonSelectBox from '../utils/ChucDanhChuyenMon';
import ChucVuDangSelectBox from '../utils/ChucVuDangSelectBox';
import ChucVuDoanSelectBox from '../utils/ChucVuDoanSelectBox';
import ChucVuSelectBox from '../utils/ChucVuSelectBox';
import DanTocSelectBox from '../utils/DanTocSelectBox';
import DonViSelectTree from '../utils/DonViSelectTree';
import NhomNhanSuSelectBox from '../utils/NhomNhanSuSelectBox';
import PhuongXaSelectBox from '../utils/PhuongXaSelectBox';
import QuocTichSelectBox from '../utils/QuocTichSelectBox';
import TinhThanhSelectBox from '../utils/TinhThanhSelectBox';
import TonGiaoSelectBox from '../utils/TonGiaoSelectBox';
import TrangThaiNhanVienSelectBox from '../utils/TrangThaiNhanVienSelectBox';
import TrinhDoLLCTSelectBox from '../utils/TrinhDoLLCTSelectBox';
import TrinhDoVanHoaSelectBox from '../utils/TrinhDoVanHoaSelectBox';
import ChungChiBox from './ChungChiBox';
import KhenThuongBox from './KhenThuongBox';
import KyLuatBox from './KyLuatBox';
import NguoiPhuThuocBox from './NguoiPhuThuocBox';
import QuaTrinhDaoTaoVaHocVanBox from './QuaTrinhDaoTaoVaHocVanBox';
import QuaTrinhLamViecVaCongTacBox from './QuaTrinhLamViecVaCongTacBox';
import NhomLyDoNghiViecSelectBox from '../utils/NhomLyDoNghiViecSelectBox';
import TextArea from 'antd/es/input/TextArea';
import DanhGiaXepLoaiBox from './DanhGiaXepLoaiBox';
import Dropzone from 'react-dropzone';

const getBase64 = (file: RcFile): Promise<string> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = (error) => reject(error);
    });
const ChiTietNhanVien = () => {
    const [isThemMoi, setIsThemMoi] = useState(true);
    const [isDangVien, setIsDangVien] = useState(false);
    const [isDoanVien, setIsDoanVien] = useState(false);
    const [isTruongThanhDoan, setIsTruongThanhDoan] = useState(false);
    const [isQuanNhan, setIsQuanNhan] = useState(false);
    const [idTinhThanhNoiO, setIdTinhThanhNoiO] = useState(0);
    const [idTinhThanhTT, setIdTinhThanhTT] = useState(0);
    const [loading, setLoading] = useState(false);
    const [reload, setReload] = useState(false);
    const [openModalLuu, setOpenModalLuu] = useState(false);
    const [form] = Form.useForm();
    const [nhanVien, setNhanVien] = useState<NhanVienResponse>(new NhanVienResponse);

    const [showModalUploadHoSo, setShowModalUploadHoSo] = useState(false);
    const [hoSoPendingFile, setHoSoPendingFile] = useState<File | null>(null);
    const [showConfirmXoaHoSo, setShowConfirmXoaHoSo] = useState(false);
    const [loadingHoSo, setLoadingHoSo] = useState(false);

    const [disableNgayNghiViec, setDisableNgayNghiViec] = useState(true)
    let navigate = useNavigate();
    const dispatch = useDispatch();

    const handleUploadHoSo = async () => {
        if (!hoSoPendingFile) return;
        try {
            setLoadingHoSo(true);
            await luuTaiLieuHoSoNhanSu(hoSoPendingFile, nhanVien.id);
            toast.success('Lưu hồ sơ nhân sự thành công!');
            setHoSoPendingFile(null);
            setShowModalUploadHoSo(false);
            setReload(true);
        } catch (err: any) {
            toast.error('Đã xảy ra lỗi, lưu hồ sơ không thành công!');
        }
        setLoadingHoSo(false);
    };

    const handleXoaHoSo = async () => {
        try {
            await xoaTaiLieuHoSoNhanSu(nhanVien.fileHoSoCaNhan.idTaiLieu);
            toast.success('Xoá hồ sơ nhân sự thành công!');
            setShowConfirmXoaHoSo(false);
            setReload(true);
        } catch (err: any) {
            toast.error('Đã xảy ra lỗi, xoá hồ sơ không thành công!');
            setShowConfirmXoaHoSo(false);
        }
    };

    const layDuLieu = async (id: number) => {
        dispatch(showLoadingScreen());
        try {
            let kq = await layCTNhanVien(id);
            setNhanVien(kq);
            form.setFieldsValue({
                id: kq.id,
                ma: kq.ma,
                hoTen: kq.hoTen,
                idDonVi: kq.idDonVi,
                dienThoai: kq.dienThoai,
                thuTu: kq.thuTu,
                email: kq.email,
                ngaySinh: dayjs(dateCommon.formatDate(kq.ngaySinh), "DD/MM/YYYY"),
                gioiTinh: kq.gioiTinh,
                isKetHon: kq.isKetHon,
                cccd: kq.cccd,
                ngayCapCCCD: dayjs(dateCommon.formatDate(kq.ngayCapCCCD), "DD/MM/YYYY"),
                noiCapCCCD: kq.noiCapCCCD,
                queQuan: kq.queQuan,
                noiSinh: kq.noiSinh,
                isQuanNhan: kq.isQuanNhan,
                isDoanVien: kq.isDoanVien,
                isDangVien: kq.isDangVien,
                soTKNganHang: kq.soTKNganHang,
                tenNganHang: kq.tenNganHang,
                chiNhanhNganHang: kq.chiNhanhNganHang,
                soNhaNoiO: kq.soNhaNoiO,
                soNhaThuongTru: kq.soNhaThuongTru,
                idChucVu: kq.idChucVu,
                idChucDanhChuyenMon: kq.idChucDanhChuyenMon == 0 ? null : kq.idChucDanhChuyenMon,
                idDanToc: kq.idDanToc,
                idNhom: kq.idNhom,
                idTrinhDoVanHoa: kq.idTrinhDoVanHoa,
                idQuocTich: kq.idQuocTich,
                idTrinhDoLLCT: kq.idTrinhDoLLCT == 0 ? null : kq.idTrinhDoLLCT,
                idTonGiao: kq.idTonGiao,
                idPhuongXaThuongTru: kq.idPhuongXaThuongTru,
                idPhuongXaNoiO: kq.idPhuongXaNoiO,
                idTinhThanhThuongTru: kq.idTinhThanhThuongTru,
                idTinhThanhNoiO: kq.idTinhThanhNoiO,
                soBHXH: kq.soBHXH,
                trangThai: kq.trangThai,
                ngayVaoLam: kq.ngayVaoLam != null ? dayjs(dateCommon.formatDate(kq.ngayVaoLam), "DD/MM/YYYY") : undefined,
                ngayTinhPhep: kq.ngayTinhPhep != null ? dayjs(dateCommon.formatDate(kq.ngayTinhPhep), "DD/MM/YYYY") : undefined,
                soNamLamCQNN: thoiGianCongTacCommon.tachNamThang(kq.soThangLamCQNN).soNam,
                soThangLamCQNNLe: thoiGianCongTacCommon.tachNamThang(kq.soThangLamCQNN).soThang,
                doiAvatar: 0,
                ngayNghiViec: kq.ngayNghiViec != null ? dayjs(dateCommon.formatDate(kq.ngayNghiViec), "DD/MM/YYYY") : undefined,
                idNhomLyDoNghiViec: kq.idNhomLyDoNghiViec == 0 ? null : kq.idNhomLyDoNghiViec,
                lyDoNghiViecCuThe: kq.lyDoNghiViecCuThe,
            });
            setIdTinhThanhTT(kq.idTinhThanhThuongTru);
            setIdTinhThanhNoiO(kq.idTinhThanhNoiO);
            setIsDangVien(kq.isDangVien);
            setIsDoanVien(kq.isDoanVien);
            setIsQuanNhan(kq.isQuanNhan);
            if (kq.isDangVien) {
                form.setFieldsValue({
                    "ngayKetNap": dayjs(dateCommon.formatDate(kq.ttDangVien.ngayKetNap), "DD/MM/YYYY"),
                    "soThe": kq.ttDangVien.soThe,
                    "noiVaoDangCT": kq.ttDangVien.noiVaoDangCT,
                    "idChucVuDang": kq.ttDangVien.idChucVuDang,
                    "ngayChinhThuc": kq.ttDangVien.ngayChinhThuc != null ? dayjs(dateCommon.formatDate(kq.ttDangVien.ngayChinhThuc), "DD/MM/YYYY") : null,
                });
            }
            if (kq.isDoanVien) {
                form.setFieldsValue({
                    "ngayVaoDoan": kq.ttDoanVien.ngayVaoDoan != null ? dayjs(dateCommon.formatDate(kq.ttDoanVien.ngayVaoDoan), "DD/MM/YYYY") : null,
                    "noiKetNapDoan": kq.ttDoanVien.noiKetNapDoan,
                    "idChucVuDoan": kq.ttDoanVien.idChucVuDoan,
                    "ngayTruongThanhDoan": kq.ttDoanVien.ngayTruongThanhDoan != null ? dayjs(dateCommon.formatDate(kq.ttDoanVien.ngayTruongThanhDoan), "DD/MM/YYYY") : null,
                    "isTruongThanhDoan": kq.ttDoanVien.isTruongThanhDoan,
                });
            }
            if (kq.isQuanNhan) {
                form.setFieldsValue({
                    "ngayKetNap": kq.ttQuanDoi.ngayNhapNgu != null ? dayjs(dateCommon.formatDate(kq.ttQuanDoi.ngayNhapNgu), "DD/MM/YYYY") : null,
                    "donViNhapNgu": kq.ttQuanDoi.donViNhapNgu,
                    "ngayXuatNgu": kq.ttQuanDoi.ngayXuatNgu != null ? dayjs(dateCommon.formatDate(kq.ttQuanDoi.ngayXuatNgu), "DD/MM/YYYY") : null,
                });
            }
            if (kq.avatar != null && kq.avatar.length > 0) {
                setFileList([{
                    uid: '-1',
                    name: 'image.png',
                    status: 'done',
                    url: urlAdmin + kq.avatar.replace(/\\/g, "/"),
                    //url: kq.avatar.replace("View\\public", urlAdmin).replace(/\\/g, "/"),
                }]);
            }
            if (kq.trangThai == 0 || kq.trangThai == 3) {
                setDisableNgayNghiViec(false);
            }
            dispatch(hideLoadingScreen());
        } catch (err) {
            toast.error('Nhân sự không tồn tại');
            navigate(Links.NhanVien.DanhSach);
            dispatch(hideLoadingScreen());
        }
    }
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [previewTitle, setPreviewTitle] = useState('');
    const [fileList, setFileList] = useState<UploadFile[]>([
    ]);

    const handleCancel = () => setPreviewOpen(false);

    const handlePreview = async (file: UploadFile) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj as RcFile);
        }

        setPreviewImage(file.url || (file.preview as string));
        setPreviewOpen(true);
        setPreviewTitle(file.name || file.url!.substring(file.url!.lastIndexOf('/') + 1));
    };

    const handleChange: UploadProps['onChange'] = ({ fileList: newFileList }) => {
        setFileList(newFileList);
        if (form.getFieldValue('doiAvatar') == 0) {
            form.setFieldValue('doiAvatar', 1);
        }
    }

    type FieldType = {
        "hoTen": string;
        "ma": string;
        "email": string;
        "dienThoai": string;
        "ngaySinh": string;
        "gioiTinh": string;
        "isKetHon": string;
        "cccd": string;
        "ngayCapCCCD": string;
        "noiCapCCCD": string;
        "queQuan": string;
        "noiSinh": string;
        "isQuanNhan": string;
        "isDoanVien": string;
        "isDangVien": string;
        "maSoThue": string;
        "soTKNganHang": string;
        "tenNganHang": string;
        "chiNhanhNganHang": string;
        "soNhaNoiO": string;
        "soNhaThuongTru": string;
        "idDonVi": string;
        "idChucVu": string;
        "idChucDanhChuyenMon": string;
        "idDanToc": string;
        "idNhom": string;
        "idQuocTich": string;
        "idTrinhDoLLCT": string;
        "idTrinhDoVanHoa": string;
        "idTonGiao": string;
        "idPhuongXaThuongTru": string;
        "idPhuongXaNoiO": string;
        "idTinhThanhThuongTru": string;
        "idTinhThanhNoiO": string;
        "soBHXH": string;
        "trangThai": string;
        "ngayVaoLam": string;
        "ngayNghiViec": string;
        "ngayTinhPhep": string;
        "soNamLamCQNN": number;
        "soThangLamCQNNLe": number;
        "idNhomLyDoNghiViec": string;
        "lyDoNghiViecCuThe": string;
        "thuTu": number;
    };
    const onFinish = (values: any) => {
        setOpenModalLuu(true);
    };
    const onSave = () => {
        form.validateFields().then(async (values) => {
            try {
                dispatch(showLoadingScreen());
                var data = {
                    id: nhanVien?.id || null,
                    hinhAnh: fileList.length > 0 ? fileList[0].originFileObj : null,
                    isDangVien: form.getFieldValue("isDangVien"),
                    ngayKetNap: form.getFieldValue("ngayKetNap"),
                    soThe: form.getFieldValue("soThe"),
                    noiVaoDangCT: form.getFieldValue("noiVaoDangCT"),
                    idChucVuDang: form.getFieldValue("idChucVuDang"),
                    ngayChinhThuc: form.getFieldValue("ngayChinhThuc"),
                    isDoanVien: form.getFieldValue("isDoanVien"),
                    ngayVaoDoan: form.getFieldValue("ngayVaoDoan"),
                    noiKetNapDoan: form.getFieldValue("noiKetNapDoan"),
                    idChucVuDoan: form.getFieldValue("idChucVuDoan"),
                    ngayTruongThanhDoan: form.getFieldValue("ngayTruongThanhDoan"),
                    isTruongThanhDoan: form.getFieldValue("isTruongThanhDoan"),
                    isQuanNhan: form.getFieldValue("isQuanNhan"),
                    donViNhapNgu: form.getFieldValue("donViNhapNgu"),
                    ngayXuatNgu: form.getFieldValue("ngayXuatNgu"),
                    ...values
                };
                data.ngaySinh = values.ngaySinh.endOf("day");
                data.soThangLamCQNN = thoiGianCongTacCommon.gopNamThang(values.soNamLamCQNN, values.soThangLamCQNNLe);
                var response: any = await luuNhanVien(data);
                if (response.trangThai === responseStatus.thanhCong) {
                    toast.success(isThemMoi ? 'Thêm mới nhân sự thành công' : "Lưu thông tin nhân sự thành công");
                    var link = Links.NhanVien.ChiTiet + "?id=" + response.duLieu;
                    navigate(link);
                } else {
                    toast.error(response.thongBao);
                }
                dispatch(hideLoadingScreen());
            } catch (error: any) {
                toast.error(error || 'Có lỗi xảy ra');
                dispatch(hideLoadingScreen());
            }

            setOpenModalLuu(false);
        }).catch((e) => {
            setOpenModalLuu(false);
        });
    }

    const onChangeTinhThanhTT = (e: any) => {
        setIdTinhThanhTT(e.target.value);
        form.setFieldValue('idPhuongXaThuongTru', undefined);
    }

    const onChangeTinhThanhNoiO = (e: any) => {
        setIdTinhThanhNoiO(e.target.value);
        form.setFieldValue('idPhuongXaNoiO', undefined);
    }

    const onChangeTrangThai = (e: any) => {
        form.setFieldValue('trangThai', e.target.value);
        if (e.target.value == 0 || e.target.value == 3) {
            setDisableNgayNghiViec(false);
        }
        else {
            form.setFieldValue('ngayNghiViec', undefined);
            setDisableNgayNghiViec(true);
        }
    }

    const disableToDay = (current: any) => {
        // Lấy ngày hôm nay
        const today = dayjs();
        // Chặn các ngày sau ngày hôm nay
        return current && current > today;
    }

    const normFile = (e: any) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    }

    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        let id = parseInt(params.get('id') || '');
        if (id > 0) {
            setIsThemMoi(false);
            layDuLieu(id);    
        }
        else {
            form.setFieldsValue({
                id: 0,
                ma: '',
                hoTen: '',
                idDonVi: null,
                dienThoai: '',
                email: '',
                ngaySinh: null,
                gioiTinh: null,
                isKetHon: null,
                cccd: '',
                ngayCapCCCD: null,
                noiCapCCCD: '',
                queQuan: '',
                noiSinh: '',
                isQuanNhan: false,
                isDoanVien: false,
                isDangVien: false,
                soTKNganHang: '',
                tenNganHang: '',
                chiNhanhNganHang: '',
                maSoThue: '',
                soNhaNoiO: '',
                soNhaThuongTru: '',
                idChucVu: null,
                idChucDanhChuyenMon: null,
                idDanToc: null,
                idNhom: null,
                idTrinhDoVanHoa: null,
                idQuocTich: null,
                idTrinhDoLLCT: null,
                idTonGiao: null,
                idPhuongXaThuongTru: null,
                idPhuongXaNoiO: null,
                idTinhThanhThuongTru: null,
                idTinhThanhNoiO: null,
                soBHXH: '',
                ngayVaoLam: null,
                ngayTinhPhep: null,
                soNamLamCQNN: 0,
                soThangLamCQNNLe: 0,
                trangThai:null,
                doiAvatar: 0,
                ngayNghiViec: null,
                idNhomLyDoNghiViec: null,
                lyDoNghiViecCuThe: ''
            });
        }
    }, []);
    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        let id = parseInt(params.get('id') || '');
        if (reload && id > 0) {
            setReload(false);      
            setIsThemMoi(false);
            layDuLieu(id);
        }
    }, [reload]);

    if (loading) {
        return (
            <LoadingDetailPage title="Thông tin nhân sự" />
        );
    }

    return (<section style={{ paddingBottom: "47px" }}>
        <ContentHeader title={isThemMoi ? "Thêm mới nhân sự" : "Chỉnh sửa nhân sự"} />
        <Modal open={previewOpen} title={previewTitle} footer={null} onCancel={handleCancel}>
            <img alt="example" style={{ width: '100%' }} src={previewImage} />
        </Modal>

        {openModalLuu && <ModalTextForm show={openModalLuu}
            title="Lưu thông tin"
            handleClose={() => setOpenModalLuu(false)}
            handleSave={onSave}>
            Xác nhận lưu thông tin nhân viên 
        </ModalTextForm>}
        <Row>
            <Col span={24}>
                <Form layout="vertical"
                    onFinish={onFinish}
                    onSubmitCapture={(e) => e.preventDefault()}
                    validateMessages={validateMessages}
                    name="complex-form"
                    form={form}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                >
                    <Button style={{ position: "fixed", zIndex: 1, right: "24px", bottom: "70px" }} type="primary" className="float-right" htmlType="submit" icon=<SaveOutlined rev="" />>
                        Lưu
                    </Button>
                    <Row >
                        <Col span="24">
                            <Tabs defaultActiveKey="1" items={[
                                {
                                    key: '1',
                                    label: 'Thông tin cá nhân',
                                    children:
                                        <div className="card pt-3 pb-2">
                                            <div className="tab-content pl-3 pr-3">
                                                <Row gutter={16}>
                                                    <Col span="8">
                                                        <div className="text-center">
                                                            <label>Ảnh đại diện</label>
                                                            <Form.Item className="text-center" valuePropName="fileList" getValueFromEvent={normFile}>
                                                                <Upload
                                                                    className="profile-user-img img-fluid img-circle"
                                                                    listType="picture-card"
                                                                    accept=".png, .jpg, .jpeg"
                                                                    fileList={fileList}
                                                                    onPreview={handlePreview}
                                                                    onChange={handleChange}
                                                                    beforeUpload={() => false}
                                                                >
                                                                    {fileList.length == 0 && '+ Thêm ảnh'}
                                                                </Upload>
                                                            </Form.Item>
                                                        </div>
                                                        <Form.Item hidden name="doiAvatar"><Input /></Form.Item>
                                                        <div style={{ marginTop: "35px" }}>
                                                            <Form.Item<FieldType>
                                                                label="Mã nhân viên"
                                                                name="ma"
                                                                rules={[{ required: true }]}
                                                            >
                                                                <Input />
                                                            </Form.Item>
                                                        </div>
                                                    </Col>
                                                    <Col span="8">
                                                        <Form.Item<FieldType>
                                                            label="Tên nhân viên"
                                                            name="hoTen" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}
                                                            rules={[{ required: true }]}
                                                        >
                                                            <Input />
                                                        </Form.Item>
                                                        <Form.Item<FieldType> name="isKetHon" label="Tình trạng hôn nhân" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                                                            <Select
                                                                placeholder="Chọn tình trạng hôn nhân"
                                                                allowClear
                                                            >
                                                                <Select.Option value={false}>Chưa kết hôn</Select.Option>
                                                                <Select.Option value={true}>Đã kết hôn</Select.Option>
                                                            </Select>
                                                        </Form.Item>
                                                        <Form.Item<FieldType>
                                                            label="Email"
                                                            name="email"
                                                            rules={[{ required: true }, { type: "email", message: 'Email không đúng định dạng!' }]}
                                                        >
                                                            <Input />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span="8">
                                                        <Row gutter={16}>
                                                            <Col span="12">
                                                                <Form.Item<FieldType> name="gioiTinh" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} label="Giới tính" rules={[{ required: true }]}>
                                                                    <Select
                                                                        placeholder="Chọn giới tính"
                                                                        allowClear
                                                                    >
                                                                        <Select.Option value={0}>Nam</Select.Option>
                                                                        <Select.Option value={1}>Nữ</Select.Option>
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span="12">
                                                                <Form.Item<FieldType> name="thuTu" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} label="Thứ tự"
                                                                    rules={[
                                                                        { required: true },
                                                                        { validator: (rule, value, callback) => validateMinMax(0, undefined, value, callback, 'Thứ tự') },
                                                                    ]}>
                                                                    <Input type="number" />
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                        <Form.Item<FieldType> name="ngaySinh" label="Ngày sinh" rules={[{ required: true }]} labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                                                            <DatePicker changeOnBlur={true} placeholder="Ngày sinh" format={["DD/MM/YYYY", "DDMMYYYY"]} style={{ width: "100%" }}
                                                                disabledDate={disableToDay} />
                                                        </Form.Item>
                                                        <Form.Item<FieldType>
                                                            label="Điện thoại"
                                                            name="dienThoai"
                                                            rules={[{ required: true }]}
                                                        >
                                                            <Input />
                                                        </Form.Item>
                                                    </Col>
                                                </Row>

                                                {/* Hồ sơ nhân sự */}
                                                <Row gutter={16} style={{ marginTop: 16 }}>
                                                    <Col span={24}>
                                                        <label>Hồ sơ nhân sự</label>
                                                    </Col>
                                                </Row>
                                                <Row gutter={16} style={{ marginTop: 8 }}>
                                                    <Col span={24}>
                                                        {nhanVien.fileHoSoCaNhan ? (
                                                            <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '6px 12px', border: '1px solid #d9d9d9', borderRadius: 6 }}>
                                                                <PaperClipOutlined />
                                                                <a href={urlAdmin + nhanVien.fileHoSoCaNhan.duongDan.replace(/\\/g, "/")} target="_blank" rel="noreferrer">
                                                                    {nhanVien.fileHoSoCaNhan.tenTep}
                                                                </a>
                                                                <DeleteOutlined
                                                                    style={{ color: 'red', cursor: 'pointer' }}
                                                                    onClick={() => setShowConfirmXoaHoSo(true)}
                                                                />
                                                            </div>
                                                        ) : (
                                                            <span style={{ color: '#999' }}>Chưa có hồ sơ</span>
                                                        )}
                                                    </Col>
                                                </Row>
                                                <Row gutter={16} style={{ marginTop: 8 }}>
                                                    <Col span={24}>
                                                        <Button
                                                            icon={<UploadOutlined />}
                                                            onClick={() => { setHoSoPendingFile(null); setShowModalUploadHoSo(true); }}
                                                        >
                                                            {nhanVien.fileHoSoCaNhan ? 'Thay thế hồ sơ' : 'Upload hồ sơ'}
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </div>

                                            {/* Modal Dropzone upload hồ sơ */}
                                            {showModalUploadHoSo && (
                                                <ModalTextForm
                                                    show={showModalUploadHoSo}
                                                    title="Upload hồ sơ nhân sự"
                                                    handleClose={() => { setShowModalUploadHoSo(false); setHoSoPendingFile(null); }}
                                                    handleSave={handleUploadHoSo}
                                                >
                                                    <Dropzone
                                                        onDrop={(acceptedFiles) => {
                                                            const file = acceptedFiles[0];
                                                            if (!file) return;
                                                            const blocked = ['.exe', '.bat', '.cmd', '.sh', '.msi', '.ps1', '.vbs', '.com', '.scr', '.pif'];
                                                            const ext = '.' + file.name.split('.').pop()?.toLowerCase();
                                                            if (blocked.includes(ext)) {
                                                                toast.warning(`File "${file.name}" không được phép upload.`);
                                                                return;
                                                            }
                                                            if (file.size > 20000000) {
                                                                toast.warning(`File vượt quá 20MB.`);
                                                                return;
                                                            }
                                                            setHoSoPendingFile(file);
                                                        }}
                                                        multiple={false}
                                                    >
                                                        {({ getRootProps, getInputProps, isDragActive }) => (
                                                            <div {...getRootProps()} className="hrm-dropzone-uploadfile">
                                                                <input {...getInputProps()} />
                                                                {isDragActive ? (
                                                                    <p>Kéo và thả tệp tin ở đây...</p>
                                                                ) : hoSoPendingFile ? (
                                                                    <div>
                                                                        <p><PaperClipOutlined /> {hoSoPendingFile.name}</p>
                                                                        <p style={{ color: '#888', marginTop: 8 }}>Nhấn hoặc kéo thả để chọn lại</p>
                                                                    </div>
                                                                ) : (
                                                                    <p>Kéo và thả hoặc nhấn để chọn hồ sơ (tối đa 20MB)</p>
                                                                )}
                                                            </div>
                                                        )}
                                                    </Dropzone>
                                                </ModalTextForm>
                                            )}

                                            {/* Modal confirm xóa hồ sơ */}
                                            {showConfirmXoaHoSo && (
                                                <ModalTextForm
                                                    show={showConfirmXoaHoSo}
                                                    title="Xoá hồ sơ nhân sự"
                                                    handleClose={() => setShowConfirmXoaHoSo(false)}
                                                    handleSave={handleXoaHoSo}
                                                >
                                                    Xác nhận xóa hồ sơ nhân sự đang chọn?
                                                </ModalTextForm>
                                            )}
                                        </div>
                                },
                            ]}>
                            </Tabs>
                        </Col>
                    </Row>
                    <Row >
                        <Col span="24">
                            <Tabs defaultActiveKey="1" items={[
                                {
                                    key: '1',
                                    label: 'Thông tin công việc',
                                    children:
                                        <div className="card pt-3 pb-2">
                                            <div className="tab-content pl-3 pr-3">
                                                <Row gutter={16}>
                                                    <Col span="8">
                                                        <Form.Item<FieldType> name="trangThai" label="Trạng thái" rules={[{ required: true }]}>
                                                            <TrangThaiNhanVienSelectBox onChange={(e: any) => { onChangeTrangThai(e) }} />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span="5">
                                                        <Form.Item<FieldType> name="ngayVaoLam" label="Ngày vào làm" rules={[{ required: true }]}>
                                                            <DatePicker changeOnBlur={true} placeholder="Ngày vào làm" format={["DD/MM/YYYY", "DDMMYYYY"]} locale={viVN} style={{ width: "100%" }}
                                                                disabledDate={disableToDay} />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span="5">
                                                        <Form.Item<FieldType> tooltip="Ngày tiếp nhận công việc tại Quỹ (mới)" name="ngayTinhPhep" label="Ngày tính phép" rules={[{ required: true }]}>
                                                            <DatePicker changeOnBlur={true} placeholder="Ngày tính phép" format={["DD/MM/YYYY", "DDMMYYYY"]} locale={viVN} style={{ width: "100%" }}
                                                                disabledDate={disableToDay} />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span="6">
                                                        <Form.Item label="Thời gian làm CQNN" required
                                                            tooltip="Tổng thời gian công tác tại cơ quan nhà nước trước khi vào Quỹ">
                                                            <Space.Compact style={{ width: "100%" }}>
                                                                <Form.Item<FieldType> name="soNamLamCQNN" noStyle
                                                                    rules={[{ required: true, message: 'Vui lòng nhập số năm' }]}>
                                                                    <InputNumber min={0} max={60} precision={0} placeholder="Năm" addonAfter="năm" style={{ width: "50%" }} />
                                                                </Form.Item>
                                                                <Form.Item<FieldType> name="soThangLamCQNNLe" noStyle
                                                                    rules={[{ required: true, message: 'Vui lòng nhập số tháng' }]}>
                                                                    <InputNumber min={0} max={11} precision={0} placeholder="Tháng" addonAfter="tháng" style={{ width: "50%" }} />
                                                                </Form.Item>
                                                            </Space.Compact>
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                                {!disableNgayNghiViec &&
                                                    <Row gutter={16}>
                                                        <Col span="8">
                                                            <Form.Item<FieldType> name="ngayNghiViec" label="Ngày nghỉ việc" rules={[{ required: !disableNgayNghiViec }]}>
                                                                <DatePicker changeOnBlur={true} placeholder="Ngày nghỉ việc" format={["DD/MM/YYYY", "DDMMYYYY"]} locale={viVN} style={{ width: "100%" }}
                                                                    disabledDate={disableToDay} />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span="8">
                                                            <Form.Item<FieldType> name="idNhomLyDoNghiViec" label="Nhóm lý do">
                                                                <NhomLyDoNghiViecSelectBox onChange={(e: any) => { form.setFieldValue('idNhomLyDoNghiViec', e.target.value); }} />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span="8">
                                                            <Form.Item<FieldType> name="lyDoNghiViecCuThe" label="Lý do cụ thể">
                                                                <TextArea rows={1} autoSize/>
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                }
                                                <Row gutter={16}>
                                                    <Col span="8">
                                                        <Form.Item<FieldType> name="idDonVi" label="Phòng ban" rules={[{ required: true }]}>
                                                            <DonViSelectTree autoSelectFirst={false} onChange={() => { }} />
                                                        </Form.Item>
                                                        <Form.Item<FieldType> name="idChucDanhChuyenMon" label="Chức danh chuyên môn">
                                                            <ChucDanhChuyenMonSelectBox onChange={(e: any) => { form.setFieldValue('idChucDanhChuyenMon', e.target.value); }} />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span="8">
                                                        <Form.Item<FieldType> name="idChucVu" label="Chức vụ" rules={[{ required: true }]}>
                                                            <ChucVuSelectBox onChange={() => { }} />
                                                        </Form.Item>
                                                        <Form.Item<FieldType> name="idTrinhDoLLCT" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} label="Trình độ LLCT">
                                                            <TrinhDoLLCTSelectBox onChange={(e: any) => { form.setFieldValue('idTrinhDoLLCT', e.target.value); }} />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span="8">
                                                        <Form.Item<FieldType> name="idNhom" label="Nhóm nhân sự" rules={[{ required: true }]}>
                                                            <NhomNhanSuSelectBox onChange={() => { }} />
                                                        </Form.Item>
                                                        <Form.Item<FieldType>
                                                            label="Số sổ BHXH"
                                                            name="soBHXH"
                                                            labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}
                                                        >
                                                            <Input />
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                },
                            ]}>
                            </Tabs>
                        </Col>
                    </Row>
                    <Row >
                        <Col span="24">
                            <Tabs defaultActiveKey="1" items={[
                                {
                                    key: '1',
                                    label: 'Thông tin chung',
                                    children:
                                        <div className="card pt-3 pb-2">
                                            <div className="tab-content pl-3 pr-3">
                                                <Row gutter={16}>
                                                    <Col span="8">
                                                        <Form.Item<FieldType>
                                                            label="Số CMND/CCCD"
                                                            name="cccd"
                                                            rules={[{ required: true }]}
                                                        >
                                                            <Input />
                                                        </Form.Item>
                                                        <Form.Item<FieldType> name="idQuocTich" label="Quốc tịch" rules={[{ required: true }]}>
                                                            <QuocTichSelectBox onChange={() => { }} />
                                                        </Form.Item>
                                                        <Form.Item<FieldType> name="idTrinhDoVanHoa" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} label="Trình độ văn hóa" rules={[{ required: true }]}>
                                                            <TrinhDoVanHoaSelectBox onChange={() => { }} />
                                                        </Form.Item>
                                                        <Form.Item<FieldType>
                                                            label="Mã số thuế"
                                                            name="maSoThue"
                                                        >
                                                            <Input />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span="8">
                                                        <Form.Item<FieldType> name="ngayCapCCCD" label="Ngày cấp CCCD" rules={[{ required: true }]}>
                                                            <DatePicker changeOnBlur={true} placeholder="Ngày cấp CCCD" format={["DD/MM/YYYY", "DDMMYYYY"]} locale={viVN} style={{ width: "100%" }}
                                                                disabledDate={disableToDay} />
                                                        </Form.Item>
                                                        <Form.Item<FieldType> name="idDanToc" label="Dân tộc" rules={[{ required: true }]}>
                                                            <DanTocSelectBox onChange={() => { }} />
                                                        </Form.Item>
                                                        <Form.Item<FieldType>
                                                            label="Quê quán"
                                                            name="queQuan"
                                                            rules={[{ required: true }]}
                                                        >
                                                            <Input />
                                                        </Form.Item>
                                                        <Form.Item<FieldType>
                                                            label="Số tài khoản"
                                                            name="soTKNganHang"
                                                        >
                                                            <Input />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span="8">
                                                        <Form.Item<FieldType>
                                                            label="Nơi cấp CMND/CCCD"
                                                            name="noiCapCCCD"
                                                        >
                                                            <Input />
                                                        </Form.Item>
                                                        <Form.Item<FieldType> name="idTonGiao" label="Tôn giáo" rules={[{ required: true }]}>
                                                            <TonGiaoSelectBox onChange={() => { }} />
                                                        </Form.Item>
                                                        <Form.Item<FieldType>
                                                            label="Nơi sinh"
                                                            name="noiSinh" rules={[{ required: true }]}
                                                        >
                                                            <Input />
                                                        </Form.Item>
                                                        <Form.Item<FieldType>
                                                            label="Ngân hàng"
                                                            name="tenNganHang"
                                                        >
                                                            <Input />
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                                <div>Nơi thường trú</div>
                                                <Row gutter={16}>
                                                    <Col span="8">
                                                        <Form.Item<FieldType> name="idTinhThanhThuongTru" label="Tỉnh/thành phố" rules={[{ required: true }]}>
                                                            <TinhThanhSelectBox onChange={onChangeTinhThanhTT} />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span="8">
                                                        <Form.Item<FieldType> name="idPhuongXaThuongTru" label="Phường/xã" rules={[{ required: true }]}>
                                                            <PhuongXaSelectBox idTinhThanh={idTinhThanhTT} onChange={() => { }} />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span="8">
                                                        <Form.Item<FieldType>
                                                            label="Số nhà/tổ/thôn/xóm..."
                                                            name="soNhaThuongTru"
                                                            rules={[{ required: true }]}
                                                        >
                                                            <Input />
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                                <div>Nơi ở hiện tại</div>
                                                <Row gutter={16}>
                                                    <Col span="8">
                                                        <Form.Item<FieldType> name="idTinhThanhNoiO" label="Tỉnh/thành phố" rules={[{ required: true }]}>
                                                            <TinhThanhSelectBox onChange={onChangeTinhThanhNoiO} />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span="8">
                                                        <Form.Item<FieldType> name="idPhuongXaNoiO" label="Phường/xã" rules={[{ required: true }]}>
                                                            <PhuongXaSelectBox idTinhThanh={idTinhThanhNoiO} onChange={() => { }} />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span="8">
                                                        <Form.Item<FieldType>
                                                            label="Số nhà/tổ/thôn/xóm..."
                                                            name="soNhaNoiO"
                                                            rules={[{ required: true }]}
                                                        >
                                                            <Input onChange={(e) => { console.log(form.getFieldsValue(['idTinhThanhNoiO'])) }} />
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                },
                                {
                                    key: '2',
                                    label: 'Thông tin Đảng',
                                    children:
                                        <div className="card pt-3 pb-2">
                                            <div className="tab-content" style={{ marginLeft: "20px" }}>
                                                <Row>
                                                    <Col span="24">
                                                        <Form.Item<FieldType> name="isDangVien"
                                                            valuePropName="checked">
                                                            <Checkbox onChange={(e) => setIsDangVien(e.target.checked)}>Là đảng viên</Checkbox>
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                                {
                                                    isDangVien &&
                                                    <Row gutter={16}>
                                                        <Col span={8}>
                                                            <Form.Item label="Số thẻ đảng viên" name='soThe'>
                                                                <Input />
                                                            </Form.Item>
                                                            <Form.Item label="Chức vụ Đảng" name="idChucVuDang">
                                                                <ChucVuDangSelectBox onChange={() => { }} />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={8}>
                                                            <Form.Item name='ngayKetNap' label="Ngày vào đảng" rules={[{ required: true }]} labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                                                                    <DatePicker changeOnBlur={true} placeholder="Ngày vào Đảng" format={["DD/MM/YYYY", "DDMMYYYY"]} locale={viVN} style={{ width: "100%" }}
                                                                    disabledDate={disableToDay} />
                                                            </Form.Item>
                                                            <Form.Item name='ngayChinhThuc' label="Ngày vào đảng chính thức" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                                                                    <DatePicker changeOnBlur={true} placeholder="Ngày vào Đảng chính thức" format={["DD/MM/YYYY", "DDMMYYYY"]} locale={viVN} style={{ width: "100%" }}
                                                                    disabledDate={disableToDay} />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={8}>
                                                            <Form.Item label="Tại chi bộ" name='noiKetNap'>
                                                                <Input placeholder="Chi bộ kết nạp" />
                                                            </Form.Item>
                                                            <Form.Item label="Tại chi bộ" name='noiVaoDangCT'>
                                                                <Input placeholder="Chi bộ kết nạp chính thức" />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                }
                                            </div>
                                        </div>
                                },
                                {
                                    key: '3',
                                    label: 'Thông tin Đoàn',
                                    children:
                                        <div className="card pt-3 pb-2">
                                            <div className="tab-content pl-3 pr-3">
                                                <Row>
                                                    <Col span="24">
                                                        <Form.Item<FieldType> name="isDoanVien"
                                                            valuePropName="checked">
                                                            <Checkbox onChange={(e) => setIsDoanVien(e.target.checked)}>Là đoàn viên</Checkbox>
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                                {
                                                    isDoanVien &&
                                                    <Row gutter={16}>
                                                        <Col span={8}>
                                                            <Form.Item name='ngayVaoDoan' label="Ngày vào Đoàn" rules={[{ required: true }]} labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                                                                    <DatePicker changeOnBlur={true} placeholder="Ngày vào Đoàn" format={["DD/MM/YYYY", "DDMMYYYY"]} locale={viVN} style={{ width: "100%" }}
                                                                    disabledDate={disableToDay} />
                                                            </Form.Item>
                                                            <div className="mb-1">
                                                                <Form.Item name='isTruongThanhDoan'
                                                                    valuePropName="checked" >
                                                                    <Checkbox onChange={(e) => setIsTruongThanhDoan(e.target.checked)}>Trưởng thành Đoàn</Checkbox>
                                                                </Form.Item>
                                                            </div>
                                                        </Col>
                                                        <Col span={8}>
                                                            <Form.Item label="Nơi kết nạp Đoàn" name='noiKetNapDoan'>
                                                                <Input placeholder="Nơi kết nạp Đoàn" />
                                                            </Form.Item>
                                                            {
                                                                isTruongThanhDoan &&
                                                                <Form.Item name='ngayTruongThanhDoan' label="Ngày trưởng thành Đoàn" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                                                                            <DatePicker changeOnBlur={true} placeholder="Ngày trưởng thành Đoàn" format={["DD/MM/YYYY", "DDMMYYYY"]} locale={viVN} style={{ width: "100%" }}
                                                                        disabledDate={disableToDay} />
                                                                </Form.Item>
                                                            }
                                                        </Col>
                                                        <Col span={8}>
                                                            <Form.Item label="Chức vụ Đoàn" name="idChucVuDoan">
                                                                <ChucVuDoanSelectBox onChange={() => { }} />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                }
                                            </div>
                                        </div>
                                },
                                {
                                    key: '4',
                                    label: 'Thông tin Quân đội',
                                    children:
                                        <div className="card pt-3 pb-2">
                                            <div className="tab-content pl-3 pr-3">
                                                <Row>
                                                    <Col span="24">
                                                        <Form.Item<FieldType> name="isQuanNhan"
                                                            valuePropName="checked">
                                                            <Checkbox onChange={(e) => setIsQuanNhan(e.target.checked)}>Là quân nhân</Checkbox>
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                                {
                                                    isQuanNhan &&
                                                    <Row gutter={16}>
                                                        <Col span={8}>
                                                            <Form.Item label="Ngày nhập ngũ" name='ngayNhapNgu'>
                                                                 <DatePicker changeOnBlur={true} placeholder="Ngày nhập ngũ" format={["DD/MM/YYYY", "DDMMYYYY"]} locale={viVN} style={{ width: "100%" }}
                                                                    disabledDate={disableToDay} />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={8}>
                                                            <Form.Item label="Ngày xuất ngũ" name='ngayXuatNgu'>
                                                                    <DatePicker changeOnBlur={true} placeholder="Ngày xuất ngũ" format={["DD/MM/YYYY", "DDMMYYYY"]} locale={viVN} style={{ width: "100%" }}
                                                                    disabledDate={disableToDay} />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={8}>
                                                            <Form.Item label="Nơi nhập ngũ" name='donViNhapNgu'>
                                                                <Input placeholder="Nơi nhập ngũ" />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                }
                                            </div>
                                        </div>
                                },
                            ]}>
                            </Tabs>
                        </Col>
                    </Row>
                </Form>
                {
                    !isThemMoi &&
                    <>
                        <Row>
                            <Col span="24">
                                <QuaTrinhLamViecVaCongTacBox listCongTac={nhanVien.quaTrinhCongTacs} listLamViec={nhanVien.quaTrinhLamViecs} idNhanVien={nhanVien.id} isThemMoiCongTac={true} isThemMoiLamViec={true} onSubmit={() => { setReload(true) }} />
                            </Col>
                        </Row>
                        <Row>
                            <Col span="24">
                                <QuaTrinhDaoTaoVaHocVanBox listHocVan={nhanVien.trinhDoHocVans} listDaoTao={nhanVien.quaTrinhDaoTaos} idNhanVien={nhanVien.id} isThemMoi={true} onSubmit={() => { setReload(true) }} />
                            </Col>
                        </Row>
                        <Row>
                            <Col span="24">
                                <ChungChiBox listData={nhanVien.chungChis} isThemMoi={true} idNhanVien={nhanVien.id} onSubmit={() => { setReload(true) }} />
                            </Col>
                        </Row>
                        <Row>
                            <Col span="24">
                                <DanhGiaXepLoaiBox listData={nhanVien.danhGiaXepLoais} isThemMoi={true} idNhanVien={nhanVien.id} onSubmit={() => { setReload(true) }} />
                            </Col>
                        </Row>
                        <Row>
                            <Col span="24">
                                <KhenThuongBox listData={nhanVien.khenThuongs} isThemMoi={true} idNhanVien={nhanVien.id} onSubmit={() => { setReload(true) }} />
                            </Col>
                        </Row>
                        <Row>
                            <Col span="24">
                                <KyLuatBox listData={nhanVien.kyLuats} isThemMoi={true} idNhanVien={nhanVien.id} onSubmit={() => { setReload(true) }} />
                            </Col>
                        </Row>
                        <Row>
                            <Col span="24" style={{ marginBottom: "10px" }}>
                                <NguoiPhuThuocBox listTaiLieu={nhanVien.dsTaiLieuNguoiPhuThuocs} listData={nhanVien.nguoiPhuThuocs} isThemMoi={true} idNhanVien={nhanVien.id} onSubmit={() => { setReload(true) }} />
                            </Col>
                        </Row>
                    </>
                }
            </Col>
        </Row>
    </section>);
};

export default ChiTietNhanVien;
